import { Pipe, PipeTransform } from '@angular/core';
import { BillingAddress, PaymentMethodInfo } from '@platform-frontend/marketplace';

@Pipe({
  name: 'isPaymentMethodOrBillingAddressDeletable'
})
export class IsPaymentMethodOrBillingAddressDeletablePipe implements PipeTransform {
  transform(value: PaymentMethodInfo | BillingAddress, updateSubscriptionWithContractId?: string | undefined | null): boolean {
    const contractIdsForConnectedSubscriptions: string[] = value.contractIdsForConnectedSubscriptions;
    const contractIdCount: number = value.contractIdsForConnectedSubscriptions.length ?? 0;
    return (
      contractIdsForConnectedSubscriptions !== null &&
      (contractIdCount === 0 || (contractIdCount === 1 && contractIdsForConnectedSubscriptions[0] === updateSubscriptionWithContractId))
    );
  }
}
